module.exports = __webpack_public_path__ + "img/9791185585321.d8052365.jpg";